import { http } from '../utils/axios';
import { IPatient } from 'shared/interfaces/patient.interface';
import {
  TInvitePatientCompleteQuestionnaireAction,
  TPatient,
  TUploadPatientFile
} from 'shared/types';
import { IAddress } from 'shared/interfaces/address.interface';
import { IQuestionnaireInstance } from 'shared/interfaces/questionnaire-instance.interface';
import { IFile } from 'shared/interfaces/file.interface';

class PatientService {
  private static instance: PatientService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): PatientService {
    if (!PatientService.instance) {
      PatientService.instance = new PatientService();
    }

    return PatientService.instance;
  }

  public getPatientInfo = async ({ limit = 20, page = 1 }) => {
    const data = await http<{
      result: IPatient[];
      count: number;
    }>({
      url: '/patients',
      method: 'GET',
      params: {
        limit,
        page
      }
    });

    return data;
  };
  public createPatient = async (payload: TPatient) => {
    const { data } = await http<IPatient>({
      url: '/patients',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public getOnePatient = async (id: string) => {
    const { data } = await http<IPatient>({
      url: `/patients/${id}`,
      method: 'GET'
    });
    return data;
  };

  public updatePatient = async (payload: { id: string; data: IPatient }) => {
    const { data } = await http<IPatient>({
      url: `/patients/${payload.id}`,
      method: 'PUT',
      data: payload.data
    });

    return data;
  };

  public addPatientAddress = async (payload: {
    owner: string;
    billing: Partial<IAddress>;
    shipping: Partial<IAddress>;
  }) => {
    const { data } = await http({
      url: `/patients/${payload.owner}/addresses`,
      method: 'POST',
      data: payload
    });

    return data;
  };

  public inviteCompleteQuestionnaire = async (
    payload: TInvitePatientCompleteQuestionnaireAction
  ) => {
    const { data } = await http<IQuestionnaireInstance>({
      method: 'POST',
      url: `/patients/${payload.id}/inviteCompleteQuestionnaire`,
      data: payload
    });

    return data;
  };

  uploadFile = async ({ patientId, body }: TUploadPatientFile) => {
    const { data } = await http<IFile>({
      method: 'POST',
      url: `/patients/${patientId}/uploadFile`,
      data: { patientId: patientId, data: body }
    });
    return data;
  };

  mergePatients = async (payload: {
    toPatient: string;
    fromPatient: string;
  }) => {
    const { data } = await http({
      method: 'PUT',
      url: '/patients/actions/merge',
      data: payload
    });
    return data;
  };
}

const instance = PatientService.getInstance();

export default instance;
